import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { adminAPI } from '../api';

// ===== PRODUCTS =====
export function Products() {
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    name: '', description: '', image_url: '', price: '',
    daily_return_rate: '', duration_days: '', total_return_rate: '',
    stock: -1, is_active: 1, sort_order: 0
  });

  const load = () => adminAPI.products().then(r => setProducts(r.data.products || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const openAdd = () => {
    setEditing(null);
    setForm({ name: '', description: '', image_url: '', price: '', daily_return_rate: '', duration_days: '', total_return_rate: '', stock: -1, is_active: 1, sort_order: 0 });
    setShowForm(true);
  };
  const openEdit = (p) => { setEditing(p); setForm(p); setShowForm(true); };

  const save = async () => {
    try {
      if (editing) {
        await adminAPI.updateProduct(editing.id, form);
        toast.success('Product updated');
      } else {
        await adminAPI.createProduct(form);
        toast.success('Product created');
      }
      setShowForm(false);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed');
    }
  };

  const deactivate = async (id) => {
    if (!window.confirm('Deactivate this product? It will be hidden from new buyers but existing purchases are unaffected.')) return;
    try { await adminAPI.deactivateProduct(id); toast.success('Deactivated'); load(); } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const deleteP = async (id) => {
    if (!window.confirm('Permanently delete this product? This cannot be undone.')) return;
    try { await adminAPI.deleteProduct(id); toast.success('Product deleted'); load(); } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={openAdd}>+ Add Product</button>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title">{editing ? 'Edit Product' : 'Add Product'}</div>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Name *</label>
                <input className="form-control" value={form.name} onChange={e => setF('name', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Price (GHS) *</label>
                <input className="form-control" type="number" value={form.price} onChange={e => setF('price', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Daily Return Rate (%) *</label>
                <input className="form-control" type="number" step="0.01" value={form.daily_return_rate} onChange={e => setF('daily_return_rate', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Duration (Days) *</label>
                <input className="form-control" type="number" value={form.duration_days} onChange={e => setF('duration_days', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Total Return Rate (%) *</label>
                <input className="form-control" type="number" step="0.01" value={form.total_return_rate} onChange={e => setF('total_return_rate', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Stock (-1 = unlimited)</label>
                <input className="form-control" type="number" value={form.stock} onChange={e => setF('stock', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Sort Order</label>
                <input className="form-control" type="number" value={form.sort_order} onChange={e => setF('sort_order', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Status</label>
                <select className="form-control" value={form.is_active} onChange={e => setF('is_active', e.target.value)}>
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Description</label>
              <textarea className="form-control" rows={3} value={form.description} onChange={e => setF('description', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">Image URL</label>
              <input className="form-control" value={form.image_url || ''} onChange={e => setF('image_url', e.target.value)} placeholder="https://..." />
              {form.image_url && (
                <div style={{ marginTop: 8 }}>
                  <img
                    src={form.image_url}
                    alt="Preview"
                    onError={e => { e.target.style.display = 'none'; }}
                    style={{ height: 80, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--gray-200)' }}
                  />
                </div>
              )}
            </div>
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => setShowForm(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={save}>Save Product</button>
            </div>
          </div>
        </div>
      )}

      <div className="table-card">
        <div className="table-header"><h3>Investment Products</h3></div>
        <table>
          <thead>
            <tr><th>ID</th><th>Image</th><th>Name</th><th>Price</th><th>Daily %</th><th>Duration</th><th>Total %</th><th>Stock</th><th>Status</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id}>
                <td>{p.id}</td>
                <td>
                  {p.image_url ? (
                    <img
                      src={p.image_url}
                      alt={p.name}
                      onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                      style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover', border: '1px solid var(--gray-200)' }}
                    />
                  ) : null}
                  <div style={{ display: p.image_url ? 'none' : 'flex', width: 48, height: 48, borderRadius: 8, background: 'var(--gray-100)', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>📊</div>
                </td>
                <td style={{ fontWeight: 600 }}>{p.name}</td>
                <td>GHS {p.price}</td>
                <td style={{ color: 'var(--success)', fontWeight: 600 }}>{p.daily_return_rate}%</td>
                <td>{p.duration_days} days</td>
                <td>{p.total_return_rate}%</td>
                <td>{p.stock === -1 ? '∞' : p.stock}</td>
                <td><span className={`badge ${p.is_active ? 'badge-active' : 'badge-suspended'}`}>{p.is_active ? 'Active' : 'Inactive'}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => openEdit(p)}>Edit</button>
                    {!!p.is_active && (
                      <button className="btn btn-ghost btn-sm" onClick={() => deactivate(p.id)}>Deactivate</button>
                    )}
                    <button className="btn btn-danger btn-sm" onClick={() => deleteP(p.id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ===== SETTINGS =====
export function Settings() {
  const [settings, setSettings] = useState([]);
  const [changes, setChanges] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminAPI.settings().then(r => setSettings(r.data.settings || [])).catch(() => {});
  }, []);

  const save = async () => {
    if (!Object.keys(changes).length) return toast.error('No changes to save');
    setSaving(true);
    try {
      const updates = Object.entries(changes).map(([key, value]) => ({ key, value }));
      await adminAPI.saveSettings(updates);
      toast.success('Settings saved!');
      setChanges({});
      // Refresh settings from server so the UI reflects the newly saved values
      adminAPI.settings().then(r => setSettings(r.data.settings || [])).catch(() => {});
    } catch { toast.error('Failed to save'); } finally { setSaving(false); }
  };

  const grouped = {
    'Fees & Limits': ['withdrawal_fee_rate', 'min_deposit', 'min_withdrawal'],
    'Bonuses': ['daily_checkin_bonus', 'registration_bonus'],
    'Referral Commission': ['referral_l1_rate', 'referral_l2_rate', 'referral_l3_rate'],
    'Payment - MTN MoMo': ['momo_mtn_number', 'momo_mtn_recipient_name'],
    'Payment - Telecel / Vodafone Cash': ['momo_vodafone_number', 'momo_vodafone_recipient_name'],
    'Payment - AirtelTigo': ['momo_airteltigo_number', 'momo_airteltigo_recipient_name'],
    'Payment - Bank Transfer': ['bank_name', 'bank_account_name', 'bank_account_number'],
    'Telegram Links': ['telegram_service_link', 'telegram_group_link', 'telegram_channel_link'],
    'Site': ['site_maintenance', 'notify_popup_enabled', 'notify_popup_message', 'withdrawal_hours'],
  };

  // Friendly labels for new keys
  const friendlyLabels = {
    momo_mtn_recipient_name: 'MTN MoMo Recipient Name (shown to users)',
    momo_vodafone_recipient_name: 'Telecel/Vodafone Cash Recipient Name (shown to users)',
    momo_airteltigo_recipient_name: 'AirtelTigo Recipient Name (shown to users)',
  };

  const getVal = (key) => changes[key] !== undefined ? changes[key] : (settings.find(s => s.setting_key === key)?.setting_value || '');
  const getDesc = (key) => friendlyLabels[key] || settings.find(s => s.setting_key === key)?.description || key.replace(/_/g, ' ');

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ fontSize: 14, color: 'var(--gray-400)' }}>{Object.keys(changes).length} unsaved change(s)</div>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : '💾 Save All Changes'}</button>
      </div>

      {Object.entries(grouped).map(([group, keys]) => (
        <div className="section-card" key={group}>
          <h3>{group}</h3>
          <div className="form-grid">
            {keys.map(key => {
              const isLong = key.includes('message') || key.includes('link');
              return (
                <div key={key} className="form-group" style={isLong ? { gridColumn: '1/-1' } : {}}>
                  <label className="form-label">{getDesc(key)}</label>
                  {isLong
                    ? <textarea className="form-control" rows={3} value={getVal(key)} onChange={e => setChanges(c => ({ ...c, [key]: e.target.value }))} />
                    : <input className="form-control" value={getVal(key)} onChange={e => setChanges(c => ({ ...c, [key]: e.target.value }))} />
                  }
                  <div style={{ fontSize: 11, color: 'var(--gray-400)', marginTop: 4 }}>Key: <code>{key}</code></div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Products;